import React, {useEffect, useState} from 'react';
import {
    DatePickerCustom,
    InputEntidad,
    InputFormat,
    InputLista,
    InputSubTasa,
    InputTasa,
    Accordion,
    FormError,
    FormLabel
} from '../../../../components/common';
import DataTaggerFormRedux from '../../../../components/controls/DataTaggerFormRedux';
import DomiciliosGrid from '../../../../components/controls/DomiciliosGrid';
import VinculosFondeaderoGrid from '../../../../components/controls/VinculosFondeaderoGrid';
import { ALERT_TYPE, CUENTA_STATE, MASK_FORMAT, OPERATION_MODE, ShowToastMessage } from '@laramie/ui';
import {MakeListDomicilios} from '../../utils';
import {ElementosTab, TabsForm} from './components';
import InputSecret from '../../../../components/common/InputSecret';
import {usePermissions} from '../../../../components/hooks/usePermissions';
import {PERMISSIONS} from '../../../../consts/permissions';


const SectionForm = ({
                         SetTabActive,
                         setPendingChange,
                         state,
                         fondeadero_formValues,
                         fondeadero_formHandleProxy,
                         cuenta_formValues,
                         cuenta_formHandleProxy,
                         UpdateEntity,
                         handleClickBaja,
                         errorOf,
                         cuentaOpen,
                         setCuentaOpen,
                         tributoOpen,
                         setTributoOpen,
                         estadoOpen,
                         setEstadoOpen,
                         pendingChange,
                         refetchFondeadero
                     }) => {

    const [domicilios, setDomicilios] = useState([]);

    const {hasPermission} = usePermissions();
    const canEditPersonasVinculadas = hasPermission(PERMISSIONS.PERSONAS_VINCULADAS_EDIT);
    const canEditElementos = hasPermission(PERMISSIONS.ELEMENTO_EDIT);

    useEffect(() => {
        if (state.entity.zonasEntrega.length > 0 || state.entity.vinculosFondeadero.length > 0) {
            MakeListDomicilios(state)
                .then(response => {
                    setDomicilios(response);
                })
                .catch(error => {
                    const message = error.message;
                    ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                    setDomicilios([]);
                });
        } else {
            if (domicilios.length > 0) setDomicilios([]);
        }
    }, [state.entity.zonasEntrega, state.entity.vinculosFondeadero])

    return (
        <>
            <section className='section-accordion'>

                <div className="m-top-20 m-bottom-20">
                    <Accordion title="Cuenta" open={cuentaOpen} onToggle={setCuentaOpen}>
                        <div className='row form-basic'>
                            <div className="col-12 col-md-3 col-lg-2">
                                <label htmlFor="cuenta_numeroCuenta" className="form-label">Número de cuenta</label>
                                <InputFormat
                                    name="cuenta_numeroCuenta"
                                    placeholder="[autonumérico]"
                                    className="form-control"
                                    mask={MASK_FORMAT.CUENTA}
                                    maskPlaceholder={null}
                                    value={cuenta_formValues.numeroCuenta}
                                    onChange={cuenta_formHandleProxy}
                                    disabled={true}
                                />
                                <FormError />
                            </div>
                            <div className="col-6 col-md-4 col-lg-2">
                                <label htmlFor="cuenta_numeroWeb" className="form-label">Clave web</label>
                                <InputSecret
                                    name="cuenta_numeroWeb"
                                    mask={MASK_FORMAT.CLAVE_WEB}
                                    maskPlaceholder={null}
                                    value={cuenta_formValues.numeroWeb}
                                    onChange={cuenta_formHandleProxy}
                                    disabled={state.mode === OPERATION_MODE.VIEW}
                                />
                                <FormError />
                            </div>
                            {(state.mode !== OPERATION_MODE.NEW) && (
                                <>
                                    <div className="col-6 col-md-4 col-lg-2">
                                        <label htmlFor="cuenta_idEstadoCuenta" className="form-label">Estado de
                                            cuenta</label>
                                        <InputLista
                                            name="cuenta_idEstadoCuenta"
                                            placeholder=""
                                            className="form-control"
                                            value={state.entity.cuenta.idEstadoCuenta}
                                            disabled={true}
                                            lista="EstadoCuenta"
                                        />
                                        <FormError />
                                    </div>
                                    <div className="col-6 col-md-4 col-lg-2">
                                        <label htmlFor="cuenta_fechaAlta" className="form-label">Fecha alta</label>
                                        <DatePickerCustom
                                            name="cuenta_fechaAlta"
                                            placeholder=""
                                            className="form-control"
                                            value={state.entity.cuenta.fechaAlta}
                                            disabled={true}
                                        />
                                        <FormError />
                                    </div>
                                    <div className="col-6 col-md-4 col-lg-2">
                                        <label htmlFor="cuenta_fechaBaja" className="form-label">Fecha baja</label>
                                        <DatePickerCustom
                                            name="cuenta_fechaBaja"
                                            placeholder=""
                                            className="form-control"
                                            value={state.entity.cuenta.fechaBaja}
                                            disabled={true}
                                        />
                                        <FormError />
                                    </div>
                                </>
                            )}
                            <div className="col-6 col-md-4 col-lg-2">
                                <FormLabel htmlFor="fondeadero_idTipoFondeadero" required>Tipo de fondeadero</FormLabel>
                                <InputLista
                                    name="fondeadero_idTipoFondeadero"
                                    placeholder=""
                                    className={`form-control ${errorOf('idTipoFondeadero') ? 'is-invalid' : ''}`}
                                    title='Tipo de fondeadero'
                                    lista='TipoFondeadero'
                                    value={fondeadero_formValues.idTipoFondeadero}
                                    onChange={fondeadero_formHandleProxy}
                                    disabled={state.mode === OPERATION_MODE.VIEW}
                                />
                                <FormError message={errorOf('idTipoFondeadero')} />
                            </div>
                        </div>
                    </Accordion>

                    {(state.mode !== OPERATION_MODE.NEW) && (
                        <>
                            <div className="m-top-20">
                                <Accordion title="Personas vinculadas">
                                    <VinculosFondeaderoGrid
                                        processKey={state.processKey}
                                        disabled={state.mode === OPERATION_MODE.VIEW || !canEditPersonasVinculadas}
                                        data={{
                                            idFondeadero: state.id,
                                            list: state.entity.vinculosFondeadero
                                        }}
                                        onChange={(typeEntity, row) => UpdateEntity(typeEntity, row)}
                                    />
                                </Accordion>
                            </div>

                            <div className="m-top-20">
                                <Accordion title="Domicilios">
                                    <DomiciliosGrid
                                        data={{
                                            list: domicilios
                                        }}
                                    />
                                </Accordion>
                            </div>

                            <div className="m-top-20">
                                <Accordion title="Información del tributo" open={tributoOpen} onToggle={setTributoOpen}>
                                    <div className='row form-basic'>
                                        <div className="col-12 col-md-6">
                                            <label htmlFor="fondeadero_idTasa" className="form-label">Tasa</label>
                                            <InputTasa
                                                name="fondeadero_idTasa"
                                                placeholder=""
                                                className="form-control"
                                                value={fondeadero_formValues.idTasa}
                                                onChange={fondeadero_formHandleProxy}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                            />
                                        </div>
                                        <div className="mb-3 col-12 col-md-6">
                                            <label htmlFor="fondeadero_idSubTasa" className="form-label">Sub
                                                tasa</label>
                                            <InputSubTasa
                                                name="fondeadero_idSubTasa"
                                                placeholder=""
                                                className="form-control"
                                                value={fondeadero_formValues.idSubTasa}
                                                onChange={fondeadero_formHandleProxy}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                idTasa={fondeadero_formValues.idTasa}
                                            />
                                        </div>
                                        <div className="col-6 col-md-4 col-lg-4">
                                            <FormLabel htmlFor="fondeadero_embarcacion" required={state.mode === OPERATION_MODE.EDIT}>Embarcación</FormLabel>
                                            <input
                                                name="fondeadero_embarcacion"
                                                type="text"
                                                placeholder=""
                                                className={`form-control ${errorOf('embarcacion') ? 'is-invalid' : ''}`}
                                                value={fondeadero_formValues.embarcacion}
                                                onChange={fondeadero_formHandleProxy}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                autoComplete="off"
                                                maxLength={250}
                                            />
                                            <FormError message={errorOf('embarcacion')} />
                                        </div>
                                        <div className="col-6 col-md-4 col-lg-2">
                                            <FormLabel htmlFor="fondeadero_superficie" required={state.mode === OPERATION_MODE.EDIT}>Superficie</FormLabel>
                                            <input
                                                name="fondeadero_superficie"
                                                type="text"
                                                placeholder=""
                                                className={`form-control ${errorOf('superficie') ? 'is-invalid' : ''}`}
                                                value={fondeadero_formValues.superficie}
                                                onChange={fondeadero_formHandleProxy}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                autoComplete="off"
                                                maxLength={20}
                                            />
                                            <FormError message={errorOf('superficie')} />
                                        </div>
                                        <div className="col-6 col-md-4 col-lg-2">
                                            <FormLabel htmlFor="fondeadero_longitud" required={state.mode === OPERATION_MODE.EDIT}>Longitud</FormLabel>
                                            <input
                                                name="fondeadero_longitud"
                                                type="text"
                                                placeholder=""
                                                className={`form-control ${errorOf('longitud') ? 'is-invalid' : ''}`}
                                                value={fondeadero_formValues.longitud}
                                                onChange={fondeadero_formHandleProxy}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                autoComplete="off"
                                                maxLength={20}
                                            />
                                            <FormError message={errorOf('longitud')} />
                                        </div>
                                        <div className="col-6 col-md-4 col-lg-2">
                                            <FormLabel htmlFor="fondeadero_codigo" required={state.mode === OPERATION_MODE.EDIT}>Código</FormLabel>
                                            <input
                                                name="fondeadero_codigo"
                                                type="text"
                                                placeholder=""
                                                className={`form-control ${errorOf('codigo') ? 'is-invalid' : ''}`}
                                                value={fondeadero_formValues.codigo}
                                                onChange={fondeadero_formHandleProxy}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                autoComplete="off"
                                                maxLength={20}
                                            />
                                            <FormError message={errorOf('codigo')} />
                                        </div>
                                        <div className="col-6 col-md-4 col-lg-2">
                                            <FormLabel htmlFor="fondeadero_club" required={state.mode === OPERATION_MODE.EDIT}>Club</FormLabel>
                                            <input
                                                name="fondeadero_club"
                                                type="text"
                                                placeholder=""
                                                className={`form-control ${errorOf('club') ? 'is-invalid' : ''}`}
                                                value={fondeadero_formValues.club}
                                                onChange={fondeadero_formHandleProxy}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                autoComplete="off"
                                                maxLength={20}
                                            />
                                            <FormError message={errorOf('club')} />
                                        </div>
                                        <div className="col-6 col-md-4 col-lg-4">
                                            <FormLabel htmlFor="fondeadero_margen" required={state.mode === OPERATION_MODE.EDIT}>Margen</FormLabel>
                                            <input
                                                name="fondeadero_margen"
                                                type="text"
                                                placeholder=""
                                                className={`form-control ${errorOf('margen') ? 'is-invalid' : ''}`}
                                                value={fondeadero_formValues.margen}
                                                onChange={fondeadero_formHandleProxy}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                autoComplete="off"
                                                maxLength={250}
                                            />
                                            <FormError message={errorOf('margen')} />
                                        </div>
                                        <div className="col-6 col-md-4 col-lg-2">
                                            <FormLabel htmlFor="fondeadero_digitoVerificador" required={state.mode === OPERATION_MODE.EDIT}>Dígito verificador</FormLabel>
                                            <input
                                                name="fondeadero_digitoVerificador"
                                                type="text"
                                                placeholder=""
                                                className={`form-control ${errorOf('digitoVerificador') ? 'is-invalid' : ''}`}
                                                value={fondeadero_formValues.digitoVerificador}
                                                onChange={fondeadero_formHandleProxy}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                autoComplete="off"
                                                maxLength={20}
                                            />
                                            <FormError message={errorOf('digitoVerificador')} />
                                        </div>
                                        <div className="col-6 col-md-4 col-lg-4">
                                            <FormLabel htmlFor="fondeadero_ubicacion" required={state.mode === OPERATION_MODE.EDIT}>Ubicación</FormLabel>
                                            <input
                                                name="fondeadero_ubicacion"
                                                type="text"
                                                placeholder=""
                                                className={`form-control ${errorOf('ubicacion') ? 'is-invalid' : ''}`}
                                                value={fondeadero_formValues.ubicacion}
                                                onChange={fondeadero_formHandleProxy}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                autoComplete="off"
                                                maxLength={250}
                                            />
                                            <FormError message={errorOf('ubicacion')} />
                                        </div>
                                        <div className="col-6 col-md-4 col-lg-2">
                                            <FormLabel htmlFor="fondeadero_fechaAlta" required={state.mode === OPERATION_MODE.EDIT}>Fecha alta</FormLabel>
                                            <DatePickerCustom
                                                name="fondeadero_fechaAlta"
                                                placeholder=""
                                                className={`form-control ${errorOf('fechaAlta') ? 'is-invalid' : ''}`}
                                                value={fondeadero_formValues.fechaAlta}
                                                onChange={fondeadero_formHandleProxy}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                            />
                                            <FormError message={errorOf('fechaAlta')} />
                                        </div>
                                    </div>
                                </Accordion>
                            </div>

                            <div className="m-top-20">
                                <Accordion title="Estado" open={estadoOpen} onToggle={setEstadoOpen}>
                                    <div className='row form-basic'>
                                        <div className="col-6 col-md-3 col-lg-3 col-xl-2">
                                            <FormLabel htmlFor="fondeadero_idEstadoCarga" required>Estado de carga</FormLabel>
                                            <InputLista
                                                name="fondeadero_idEstadoCarga"
                                                placeholder=""
                                                className={`form-control ${errorOf('idEstadoCarga') ? 'is-invalid' : ''}`}
                                                value={fondeadero_formValues.idEstadoCarga}
                                                onChange={fondeadero_formHandleProxy}
                                                disabled={state.mode === OPERATION_MODE.VIEW || state.entity.fondeadero.idEstadoCarga !== 20}
                                                lista="EstadoCarga"
                                            />
                                            <FormError message={errorOf('idEstadoCarga')} />
                                        </div>
                                        <div className="col-6 col-md-3 col-lg-3 col-xl-2">
                                            <label htmlFor="fondeadero_fechaCargaInicio" className="form-label">Fecha
                                                inicio carga</label>
                                            <DatePickerCustom
                                                name="fondeadero_fechaCargaInicio"
                                                placeholder=""
                                                className="form-control"
                                                value={state.entity.fondeadero.fechaCargaInicio}
                                                disabled={true}
                                            />
                                            <FormError />
                                        </div>
                                        <div className="col-6 col-md-3 col-lg-3 col-xl-2">
                                            <label htmlFor="fondeadero_fechaCargaFin" className="form-label">Fecha fin
                                                carga</label>
                                            <DatePickerCustom
                                                name="fondeadero_fechaCargaFin"
                                                placeholder=""
                                                className="form-control"
                                                value={state.entity.fondeadero.fechaCargaFin}
                                                disabled={true}
                                            />
                                            <FormError />
                                        </div>
                                        <div className="col-6 col-md-3 col-lg-3 col-xl-6">
                                            {state.mode === OPERATION_MODE.EDIT && state.entity.cuenta.idEstadoCuenta === CUENTA_STATE.ACTIVA &&
                                                <button className="btn action-button float-end m-top-30"
                                                        onClick={(event) => handleClickBaja()}>Baja</button>
                                            }
                                        </div>
                                    </div>
                                </Accordion>
                            </div>

                            <div className="m-top-20">
                                <Accordion title="Elementos">
                                    <ElementosTab {...{state, UpdateEntity}} />
                                </Accordion>
                            </div>

                            <div className="m-top-20">
                                <Accordion title="Información adicional ">
                                    <DataTaggerFormRedux
                                        title="Información adicional de fondeadero"
                                        processKey={state.processKey}
                                        entidad="Fondeadero"
                                        idEntidad={state.id}
                                        disabled={(state.mode === OPERATION_MODE.VIEW)}
                                        onChange={(row) => setPendingChange(true)}
                                    />
                                </Accordion>
                            </div>

                            <TabsForm
                                state={state}
                                SetTabActive={SetTabActive}
                                UpdateEntity={UpdateEntity}
                                pendingChange={pendingChange}
                                refetchFondeadero={refetchFondeadero}
                            />

                        </>
                    )}

                </div>

            </section>
        </>
    )
}
export default SectionForm
